import { Button, Space } from 'antd';
import { getTranslatedString } from 'helpers/i18n';
import React, { useContext } from 'react';
import { ApplicationUIContext, Form, Table, useDrawerState } from 'ui-library';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import IncentiveCodeDrawer from './IncentiveCodeDrawer';
import moment from 'moment';

const TableRowActions = ({ onUpdate, onDelete, record }) => {
  const [, editDrawer] = useDrawerState(false);

  return (
    <>
      <Space size="middle">
        <Button type="link" icon={<EditOutlined />} onClick={editDrawer.open} />
        <Button type="link" icon={<DeleteOutlined />} onClick={onDelete} />
      </Space>

      <IncentiveCodeDrawer drawer={editDrawer} onAdd={onUpdate} initialValues={record} />
    </>
  );
};

const IncentiveCodesTable = ({ codes, operations }) => {
  const { isMobile } = useContext(ApplicationUIContext);
  const IncentiveCodesForm = Form.useFormInstance();

  const columns = [
    {
      title: getTranslatedString('landlordPortal.incentives.code'),
      dataIndex: 'code',
      key: 'code',
      render(_, row) {
        return (
          <Form.Item shouldUpdate>
            {({ getFieldValue }) => {
              return getFieldValue(['incentive_codes', row.name, 'code']);
            }}
          </Form.Item>
        );
      },
    },
    {
      title: getTranslatedString('landlordPortal.incentives.validFrom'),
      dataIndex: 'valid_from',
      key: 'valid_from',
      render(_, row) {
        return (
          <Form.Item shouldUpdate>
            {({ getFieldValue }) => {
              const valid_from = getFieldValue(['incentive_codes', row.name, 'valid_from']);
              if (!valid_from) return null;
              return moment(valid_from).format('YYYY-MM-DD');
            }}
          </Form.Item>
        );
      },
    },
    {
      title: getTranslatedString('landlordPortal.incentives.validTo'),
      dataIndex: 'valid_to',
      key: 'valid_to',
      render(_, row) {
        return (
          <Form.Item shouldUpdate>
            {({ getFieldValue }) => {
              const valid_to = getFieldValue(['incentive_codes', row.name, 'valid_to']);
              if (!valid_to) return null;
              return moment(valid_to).format('YYYY-MM-DD');
            }}
          </Form.Item>
        );
      },
    },
    {
      key: 'actions',
      render: (_, record, index) => (
        <TableRowActions
          onUpdate={(updatedRecord) => {
            operations.remove(record.name);
            operations.add(updatedRecord);
          }}
          onDelete={() => operations.remove(record.name)}
          record={IncentiveCodesForm.getFieldValue('incentive_codes')[index]}
        />
      ),
    },
  ];

  return (
    <Table
      dataSource={codes}
      columns={columns}
      hideActionAndSearch
      size={isMobile ? 'middle' : 'small'}
      scroll={{ x: isMobile }}
    />
  );
};

export default IncentiveCodesTable;
